import React from 'react';

// Packages
import { Button, Card, Col, Divider, Row, Space, Steps, Typography } from 'antd';

const SUPPORT_EMAIL = 'info@kitchenandmanners.com';

const DeleteAccount = () => {
	const mailtoHref =
		`mailto:${SUPPORT_EMAIL}` +
		'?subject=' + encodeURIComponent('Solicitud de eliminación de cuenta') +
		'&body=' + encodeURIComponent(
			'Hola,\n\nDeseo eliminar mi cuenta y todos mis datos ' +
			'asociados a Kitchen & Manners.\n\n' +
			'Correo de mi cuenta: \n\nGracias.'
		);

	return (
		<div
			style={{
				padding: '0 16px',
				maxWidth: '100%',
				width: '100%',
				margin: '0 auto'
			}}
		>
			<Row justify='center'>
				<Col xs={24} sm={22} md={18} lg={14} xl={12}>
					<Space
						direction='vertical'
						size='large'
						style={{ width: '100%', marginTop: '3rem', marginBottom: '3rem' }}
					>
						<div>
							<Typography.Title level={2} style={{ marginBottom: '0.5rem' }}>
								Eliminación de cuenta y datos
							</Typography.Title>
							<Typography.Text type='secondary'>
								Kitchen &amp; Manners
							</Typography.Text>
						</div>

						<Card
							bordered={false}
							style={{
								boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
								borderRadius: 23
							}}
						>
							<Typography.Paragraph style={{ fontSize: '1.05rem', marginBottom: 0 }}>
								Para eliminar tu información debes mandar un correo a{' '}
								<Typography.Link href={`mailto:${SUPPORT_EMAIL}`} strong>
									{SUPPORT_EMAIL}
								</Typography.Link>{' '}
								con tu correo y nosotros borraremos tu cuenta y datos en los
								siguientes <Typography.Text strong>7 días hábiles</Typography.Text>.
							</Typography.Paragraph>

							<Divider />

							<Steps
								direction='vertical'
								current={-1}
								items={[
									{
										title: 'Envía tu solicitud',
										description: (
											<>
												Escribe a{' '}
												<Typography.Text strong>{SUPPORT_EMAIL}</Typography.Text>{' '}
												indicando el correo asociado a tu cuenta.
											</>
										)
									},
									{
										title: 'Verificamos tu cuenta',
										description:
											'Confirmamos que el correo corresponde a una cuenta ' +
											'registrada en Kitchen & Manners.'
									},
									{
										title: 'Eliminamos tu información',
										description:
											'Tu cuenta y datos asociados se borran dentro de los ' +
											'7 días hábiles siguientes a tu solicitud.'
									}
								]}
							/>

							<Divider />

							<Space direction='vertical' size='small' style={{ width: '100%' }}>
								<Button
									type='primary'
									size='large'
									href={mailtoHref}
									block
								>
									Solicitar eliminación de mi cuenta
								</Button>
								<Typography.Text type='secondary' style={{ fontSize: '0.85rem' }}>
									Se abrirá tu aplicación de correo con un mensaje prellenado.
								</Typography.Text>
							</Space>
						</Card>
					</Space>
				</Col>
			</Row>
		</div>
	);
};

export default DeleteAccount;
